import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/ant-design-vue.js'
import '@babel/polyfill'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import crypto from './plugins/crypto'
import 'vue-g2'

axios.defaults.withCredentials = true

Vue.prototype.$crypto = crypto
Vue.use(VueCookies)
Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
